module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/empty-layout.component.html
// module chunks = main